var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrow",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9l-6 6-6-6",
    strokeWidth: 1.5
  })));
};
export default __webpack_public_path__ + "assets/993c99f7b36859a415b6138a8779a9f7.svg";
export { SvgArrow as ReactComponent };


// WEBPACK FOOTER //
// ./components/inputs/icons/Arrow.svg